/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.programs.combos.create.controllers', [
  'acme.common.service.api',
  'acme.common.factory.notice'
])

.controller('ProgramsCombosCreateController', ['$scope', '$state', '$timeout', 'ApiService', 'NoticeFactory', function($scope, $state, $timeout, ApiService, NoticeFactory) {

    var transtionTimer,
        navigateTimer;

    $scope.programsCombosCreate = {

      model: {
        id: ''
      },
      componentType: 'comboEventTemplate',
      notice: new NoticeFactory(),

      init: function() {
        var title = {
          title: 'Create Combo'
        };

        if ($state.params && $state.params.comboId) {
          this.model.id = $state.params.comboId;
          title = {
            title: 'Edit Combo'
          };
        }

        $scope.$emit('Application::contentTitleChange', title);
        $scope.$on('$destroy', this.onDestroy);

        $scope.$on('ProgramsCombosCreateController::reset', this.onReset);
        $scope.$on('ProgramsCombosCreateController::error', this.onError);
        $scope.$on('ProgramsCombosCreateController::success', this.onSuccess);
        $scope.$on('ProgramsCombosCreateController::transition', this.onTransition);
      },

      save: function(next) {
        $scope.$broadcast('ProgramsCombosCreateController::save', { state: next });
      },

      isActiveState: function(state) {
        var r = false,
            regex = new RegExp(state + "$");

        if ($state.current.name.match(regex)) {
          r = true;
        }

        return r;
      },

      success: {
        init: function(response) {
        }
      },

      error: {
        init: function(response) {}
      },

      onReset: function(e, data) {
        $scope.programsCombosCreate.notice.hideErrorMessages();
        $scope.programsCombosCreate.notice.hideSuccessMessages();
      },
      onError: function(e, data) {
        $scope.programsCombosCreate.notice.hideSuccessMessages();
        $scope.programsCombosCreate.notice.showErrorMessages([{
          message: data.message
        }]);
      },
      onSuccess: function(e, data) {
        $scope.programsCombosCreate.notice.hideErrorMessages();
        $scope.programsCombosCreate.notice.showSuccessMessages([{
          message: data.message
        }]);
      },

      onTransition: function(e, data) {
        if (transtionTimer) {
          $timeout.cancel(transtionTimer);
        }
        if (navigateTimer) {
          $timeout.cancel(navigateTimer);
        }
        transtionTimer = $timeout(function() {
          $scope.programsCombosCreate.onReset();
          navigateTimer = $timeout(function() {
            $state.go(data.state);
          }, 300);
        }, 3000);
      }

    };

    $scope.programsCombosCreate.init();

}]);